<template>
  <div id="main" sticky-container>
    <navigation/>
    <router-view/>
    <sui-footer/>
  </div>
</template>
<script>
import navigation from '@/components/navigation'

import footer from '@/sui/components/footer'

export default {
  components: {
    'navigation': navigation,
    'sui-footer': footer
  }
}
</script>
<style >
</style>
